/**
 * Generates all double-digit numbers (00, 11, 22, etc.)
 * @returns Array of double-digit number strings
 */
export const generateDoubleNumber = (): string[] => {
  const result = []
  for (let i = 0; i < 10; i++) {
    result.push(`${i}${i}`)
  }
  return result
}

/**
 * Generates low numbers (00-49)
 * @returns Array of low number strings
 */
export const generateLowNumber = (): string[] => {
  const result = []
  for (let i = 0; i < 50; i++) {
    if (i < 10) {
      result.push(`0${i}`)
    } else {
      result.push(`${i}`)
    }
  }
  return result
}

/**
 * Generates high numbers (50-99)
 * @returns Array of high number strings
 */
export const generateHighNumber = (): string[] => {
  const result = []
  for (let i = 50; i < 100; i++) {
    result.push(`${i}`)
  }
  return result
}

/**
 * Generates odd numbers (01, 03, 05, etc.)
 * @returns Array of odd number strings
 */
export const generateOddNumber = (): string[] => {
  const result = []
  for (let i = 1; i < 100; i += 2) {
    const numStr = i.toString().padStart(2, '0')
    result.push(numStr)
  }
  return result
}

/**
 * Generates even numbers (00, 02, 04, etc.)
 * @returns Array of even number strings
 */
export const generateEvenNumber = (): string[] => {
  const result: string[] = []
  for (let i = 0; i < 100; i += 2) {
    result.push(i.toString().padStart(2, '0'))
  }
  return result
}
